import React, {
  createContext,
  PropsWithChildren,
  useContext,
  useEffect,
  useMemo,
  useState,
} from 'react';
import { initialize } from 'launchdarkly-js-client-sdk';
import { TenantInfoContext } from 'providers/TenantInfo/TenantInfo';

const globalWithEnv = globalThis as typeof globalThis & {
  env: {
    launchDarkly: {
      clientSideID: string;
    };
  };
};

export const DEFAULT_FIREBASE_CONFIG = {
  apiKey: 'AIzaSyCY1J3__41nPBbmfaNeNNgO1SwkT4zkLeU',
  authDomain: 'hiidentity-staff.firebaseapp.com',
  databaseURL: 'https://hiidentity-staff.firebaseio.com',
  projectId: 'hiidentity-staff',
  storageBucket: 'hiidentity-staff.appspot.com',
  messagingSenderId: '507969065515',
  appId: '1:507969065515:web:74378c7d42cd5838b7906e',
};

export const GlobalFeatureFlagsContext = createContext({
  isReady: false,
  firebaseConfig: DEFAULT_FIREBASE_CONFIG,
});

export const GlobalFeatureFlagsProvider: React.FC<PropsWithChildren<unknown>> = ({ children }) => {
  const { tenantInfo, loading } = useContext(TenantInfoContext);
  const [firebaseConfig, setFirebaseConfig] = useState(DEFAULT_FIREBASE_CONFIG);
  const [isReady, setIsReady] = useState(false);
  const [
    isFirebaseMigrationFeatureFlagValueChanged,
    setIsFirebaseMigrationFeatureFlagValueChanged,
  ] = useState(false);

  const launchDarklyClient = useMemo(() => {
    if (!loading && tenantInfo) {
      return initialize(globalWithEnv.env.launchDarkly.clientSideID, {
        // @ts-ignore
        key: 'extenda',
        email: 'anonymous',
        anonymous: true,
        custom: {
          tenantId: tenantInfo.tenantId,
          userType: 'staff',
        },
      });
    }

    return null;
  }, [loading, tenantInfo]);

  if (launchDarklyClient) {
    launchDarklyClient.on('ready', () => {
      setIsFirebaseMigrationFeatureFlagValueChanged(
        launchDarklyClient.variation('release.firebase-migration'),
      );
      setIsReady(true);
    });

    launchDarklyClient.on('change', () => {
      setIsFirebaseMigrationFeatureFlagValueChanged(
        launchDarklyClient.variation('release.firebase-migration'),
      );
    });
  }
  useEffect(() => {
    setFirebaseConfig((prev) => ({
      ...prev,
      authDomain:
        isFirebaseMigrationFeatureFlagValueChanged && process.env.NODE_ENV === 'production'
          ? globalThis.location.host
          : DEFAULT_FIREBASE_CONFIG.authDomain,
    }));
  }, [isFirebaseMigrationFeatureFlagValueChanged]);

  const globalFeatureFlagsContextValueWrapper = useMemo(
    () => ({ isReady, firebaseConfig }),
    [firebaseConfig, isReady],
  );

  return (
    <GlobalFeatureFlagsContext.Provider value={globalFeatureFlagsContextValueWrapper}>
      {children}
    </GlobalFeatureFlagsContext.Provider>
  );
};
